import {
    List,
    Datagrid,
    TextField,
    TopToolbar,
    CreateButton,
    ExportButton,
    useRecordContext,
    FieldProps,
    Link,
    ReferenceManyCount,
    useDataProvider,
    Loading,
    BooleanField,
    Filter,
    TextInput,
    useGetList,
    AutocompleteInput,
} from 'react-admin';
import ThumbnailField from '../../common/ThumbnailField';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import { Edit, Visibility } from '@mui/icons-material';
import { Batches, Test_Serieses } from '../../custom';
import { NoDataSection } from '../../common/NoDataSection';
import FormattedDateTimeField from '../../common/FormattedDateTimeField';
import { useQuery } from 'react-query';
import StatusTags from '../../common/StatusTags';
import ConfirmDeleteButton from '../../common/ConfirmDeleteButton';
import { ProgramAutocomplete } from '../../common/inputs/autoCompleteInputs/ProgramAutoComplete';

const ListActions = () => {
    const navigate = useNavigate();
    return (
        <TopToolbar>
            <CreateButton
                onClick={e => {
                    e.preventDefault();
                    navigate(`/test-series/create`);
                }}
            />
            <ExportButton />
        </TopToolbar>
    );
};

const EditButton = () => {
    const navigate = useNavigate();
    const record: Test_Serieses = useRecordContext<Test_Serieses>();
    return (
        <Button
            onClick={e => {
                navigate(`/test-series/${record.id}/edit`);
            }}
        >
            <Edit />
        </Button>
    );
};

const TestsLinkField = (props: FieldProps<Test_Serieses>) => {
    const record = useRecordContext<Test_Serieses>();
    if (!record) return null;

    return (
        <Link
            to={`/test-series/${record?.id}/tests?filter=${encodeURIComponent(
                JSON.stringify({ testSeriesId: record.id }),
            )}`}
        >
            Tests
        </Link>
    );
};

const ShowTestSeries = (props: FieldProps<Test_Serieses>) => {
    const record = useRecordContext<Test_Serieses>();
    if (!record) {
        return null;
    }
    return (
        <Link to={`/test-series/${record.id}/show`}>
            <Button>
                <Visibility />
            </Button>
        </Link>
    );
};

const Actions = () => {
    return (
        <div className={'flex'}>
            <ShowTestSeries />
            <EditButton />
            <ConfirmDeleteButton />
        </div>
    );
};

Actions.defaultProps = {
    label: 'Actions',
};

const TestSeriesFilters = (props: any) => {
    return (
        <Filter {...props}>
            <TextInput
                variant={'outlined'}
                label="Title"
                source="title"
                alwaysOn={true}
                defaultValue=""
            />
            <ProgramAutocomplete alwaysOn />
        </Filter>
    );
};

const TestSeriesList = () => {
    const navigate = useNavigate();
    return (
        <List
            empty={
                <NoDataSection
                    resource={'test-series'}
                    onCreate={() => {
                        navigate(`/test-series/create`);
                    }}
                />
            }
            sort={{ field: 'created_at', order: 'DESC' }}
            resource={'test-series'}
            actions={<ListActions />}
            filters={<TestSeriesFilters />}
            queryOptions={{
                refetchOnWindowFocus: false,
                refetchOnReconnect: false,
            }}
        >
            <Datagrid bulkActionButtons={false}>
                <ThumbnailField source="image" sortable={false} />
                <TextField source="title" sortable={false} />
                <TextField source="displayOrder" sortable />
                <StatusTags source="status" label={'Status'} sortable={false} />
                <TextField source="type" sortable={false} />
                <BooleanField source="isDemo" sortable={false} />
                <TestsLinkField />
                <FormattedDateTimeField source="createdAt" sortable />
                <Actions />
            </Datagrid>
        </List>
    );
};
export default TestSeriesList;
